import api from './api';
import { getCachedProducts, searchCachedProducts, getSetting, saveSetting } from './offlineDB';
import { isPOSAvailable } from './posAvailability';

export const POS_PAGE_SIZE = 15;
export const POS_FREQUENT_LIMIT = 100;
const branchId = () => {
  try {
    const user = JSON.parse(localStorage.getItem('pharmxai_user'));
    return user?.selected_tenant_id || user?.tenant_id;
  } catch { return null; }
};

export const loadCachedCatalog = async (search, page) => {
  const branch = branchId();
  if (!branch || await getSetting('cached_branch_id') !== branch) return { products: [], total: 0 };
  let products;
  if (search.trim()) products = await searchCachedProducts(search.trim());
  else {
    const snapshot = await getSetting('frequent_products');
    const all = new Map((await getCachedProducts()).map(p => [p.product_id, p]));
    products = snapshot?.branch_id === branch
      ? snapshot.ids.map(id => all.get(id)).filter(p => p && p.stock_quantity > 0 && !p.recall_locked)
      : [];
  }
  products = products.filter(product => isPOSAvailable(product));
  if (!search.trim()) {
    products = products.slice(0, POS_FREQUENT_LIMIT);
    return { products, total: products.length };
  }
  return { products: products.slice((page - 1) * POS_PAGE_SIZE, page * POS_PAGE_SIZE), total: products.length };
};

export const loadOnlineCatalog = async (search, page) => {
  const requestedBranch = branchId();
  if (search.trim()) {
    const { data } = await api.get('/products', { params: { search: search.trim(), page, limit: POS_PAGE_SIZE, pos_available: true }, timeout: 8000 });
    return data;
  }
  const { data } = await api.get('/products/frequent', { params: { limit: POS_FREQUENT_LIMIT }, timeout: 8000 });
  if (branchId() === requestedBranch && data.branch_id === requestedBranch) {
    await saveSetting('frequent_products', { branch_id: requestedBranch, ids: data.products.map(p => p.product_id) });
  }
  return data;
};